import React from "react";
const IconPickUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M12.332 12.964A19.495 19.495 0 0 1 10 15a19.49 19.49 0 0 1-2.331-2.036C5.993 11.24 5 9.504 5 7.91 5 5.13 7.133 3 10 3s5 2.13 5 4.91c0 1.593-.993 3.33-2.668 5.054Z"
    />
    <circle cx="10" cy="7.5" r="1.5" fill="currentColor" />
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M7.138 12c-.438.073-.853.163-1.238.267-1.757.475-2.9 1.247-2.9 2.12C3 15.83 6.134 17 10 17s7-1.17 7-2.614c0-.872-1.143-1.644-2.9-2.119-.385-.104-.8-.194-1.238-.267"
    />
  </svg>
);
export default IconPickUp;
